import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import UtilsService from '../../service/UtilsService';
import { REF_LOCAL_ENUM } from '../utils/TranscoUtils'
import Traductions from '../../traductions/traductions.json';
import MenuItem from '../core/MenuItem';

const mapStateToProps = (state) => {
    return { aggrega: state.reduceAggrega.aggrega }
}

export default connect(mapStateToProps)(Language);

function Language(props) {
    const { t, i18n } = useTranslation('common');
    const [lang, setLang] = useState('');

    useEffect(() => {
        let lang = localStorage.getItem('langRef');
        lang = lang ? lang : 'fr';
        setFlag(lang);
    }, []);

    const setFlag = (language) => {
        let trad = Traductions.filter(t => t.language === language);
        if (trad.length) {
            //    const flag = require('../img/pays/'+trad[0].flag);
            setLang(trad[0].language);
        } else {
            setLang('fr');
        }
    }

    const handleSelectLanguage = async (event) => {
        const langSelected = event.target.textContent;
        setLang(langSelected);
        i18n.changeLanguage(langSelected);
        localStorage.setItem("langRef", langSelected)
        // Rechargement des reférentiels
        localStorage.setItem(REF_LOCAL_ENUM.status.value, JSON.stringify({ "ATR": t('STA_001'), "ENC": t('STA_002'), "TRA": t('STA_003') }));
        localStorage.setItem(REF_LOCAL_ENUM.roles.value, JSON.stringify({"EXTC-ADMIN": t('ROL_001'),"EXTC-DATA": t('ROL_002'),"EXTC-DOSS": t('ROL_003'),"EXTC-MESS": t('ROL_004'),"EXTC-EMESS": t('ROL_005'),"EXTC-REPORTING": t('ROL_006'),"EXTC-TASK": t('ROL_007'),"EXTC-USER": t('ROL_008'),"EXTC-REPAIRS": t('ROL_009'), "EXTC-SUIVIGARANTIES": t('ROL_010'), "EXTC-DECISIONGARANTIES": t('ROL_011')}));
        localStorage.setItem(REF_LOCAL_ENUM.activities.value, JSON.stringify({"DEP": t('ACT_001'),"HAB": t('ACT_002'),"MOB": t('ACT_003'),"SAN": t('ACT_004')}));
        localStorage.setItem(REF_LOCAL_ENUM.customers_types.value, JSON.stringify({"AC": t('TYP_CUST_001'),"CO": t('TYP_CUST_002'),"LO": t('TYP_CUST_003'),"MO": t('TYP_CUST_004'), "SA": t('TYP_CUST_005')}));

        await UtilsService.refreshRef(langSelected, true);
        props.dispatch({ type: "UPDATE_LANG", lang: langSelected });
        props.dispatch({ type: "REFRESH_AGGREGA" });
        props.dispatch({ type: "REFRESH_AGGREGA_SDR" });
    }

    const getItems = () => {
        let items = {};
        Traductions.filter(trad => trad.language !== lang).map(trad =>
            items[trad.language] = handleSelectLanguage
        );
        return items;
    }

    const getTitle = () => {
        return <span>{lang}</span>
    }

    return (
        <MenuItem title={getTitle()} items={getItems()} />
    );
}

